import { MdOutlineRemoveCircle } from 'react-icons/md';
import { ApplicantDocument } from '../../types/applications';

const AddedDocumentTable = ({
  addedDocuments,
  setAddedDocuments,
}: {
  addedDocuments: Array<ApplicantDocument>;
  setAddedDocuments: React.Dispatch<
    React.SetStateAction<Array<ApplicantDocument>>
  >;
}) => {
  // rendering added document table component here
  return (
    <div className='w-full overflow-x-auto'>
      <div className='min-w-[700px] border-2 border-legal-dark-blue rounded-lg'>
        <div className='grid grid-cols-[200px_200px_1fr_60px] xl:grid-cols-[300px_300px_1fr_60px] text-center text-legal-dark-blue font-semibold [&>div:not(:last-child)]:border-r [&>div:not(:last-child)]:border-legal-dark-blue [&>div]:py-2 border-b-2 border-legal-dark-blue bg-gray-100 rounded-t-lg'>
          <div>
            <p>Document Name</p>
          </div>

          <div>
            <p>File Name</p>
          </div>

          <div>
            <p>Additional Notes</p>
          </div>

          <div></div>
        </div>

        <div className='[&>div:not(:last-child)]:border-b [&>div:not(:last-child)]:border-legal-dark-blue'>
          {addedDocuments.map((doc, index) => (
            <div
              key={index}
              className='grid grid-cols-[200px_200px_1fr_60px] xl:grid-cols-[300px_300px_1fr_60px] text-center text-legal-dark-blue [&>div:not(:last-child)]:border-r [&>div:not(:last-child)]:border-legal-dark-blue [&>div]:py-2'
            >
              <div title={doc.document_name}>
                <p className='truncate px-1'>{doc.document_name}</p>
              </div>

              <div title={doc.document_file.name}>
                <p className='truncate px-1'>{doc.document_file.name}</p>
              </div>

              <div title={doc.notes}>
                <p className='truncate px-1'>{doc.notes || 'N/A'}</p>
              </div>

              <div className='flex items-center justify-center'>
                <button
                  type='button'
                  onClick={() =>
                    setAddedDocuments((state) =>
                      state.filter(
                        (existingDoc) =>
                          existingDoc.document_name !== doc.document_name
                      )
                    )
                  }
                  className='rounded-full'
                >
                  <MdOutlineRemoveCircle className='size-5 text-base-red hover:opacity-70 active:scale-95 duration-300' />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AddedDocumentTable;
